var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinFondo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#14B497",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#14B497",
    strokeWidth: 1.667,
    d: "M69.284 12.716C61.73 5.16 51.684 1 41 1 30.316 1 20.27 5.16 12.716 12.716 5.16 20.27 1 30.316 1 41c0 10.684 4.16 20.73 11.716 28.284C20.27 76.84 30.316 81 41 81c10.684 0 20.73-4.16 28.284-11.716C76.84 61.73 81 51.684 81 41c0-10.684-4.16-20.73-11.716-28.284zM41 76.312C21.529 76.313 5.687 60.472 5.687 41 5.688 21.529 21.53 5.687 41 5.687 60.471 5.688 76.313 21.53 76.313 41c0 19.471-15.842 35.313-35.313 35.313z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.51 38.656h-5.02a5.193 5.193 0 0 1-5.188-5.187 5.193 5.193 0 0 1 5.188-5.188H48.53a2.344 2.344 0 0 0 0-4.687h-5.187v-5.188a2.344 2.344 0 0 0-4.688 0v5.188h-.166c-5.445 0-9.875 4.43-9.875 9.875s4.43 9.875 9.875 9.875h5.02a5.193 5.193 0 0 1 5.188 5.187 5.193 5.193 0 0 1-5.187 5.188H33.469a2.344 2.344 0 0 0 0 4.687h5.187v5.188a2.344 2.344 0 0 0 4.688 0v-5.188h.166c5.445 0 9.875-4.43 9.875-9.875s-4.43-9.875-9.875-9.875z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinFondo);
export default __webpack_public_path__ + "static/media/coin-fondo.bb391f65f35f8f88634377668f0ccbc0.svg";
export { ForwardRef as ReactComponent };